import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { IDesignProjectId, IDesignProjectCategoryId } from '../../interfaces/DesignProject';
import additionalDataFactory from './common/fieldsAdditionalData';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const dpFastFoodForm: IForm = {
    formId       : PublishedFormId.DpHotel,
    type         : FormTypeId.DesignProject,
    thumbnailURL : '/resized-images/forms/dpHotel.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DesignProject,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        designProject: {
            [IDesignProjectCategoryId.LobbyLounge]: {
                [IDesignProjectId.ReceptionDesk]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Sofa]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.EatStandingUp]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.BenchLong]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Bench]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Table]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.GreenWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.TiledFloorLobyLounge]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.WaxedConcreteFloorLobyLounge]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.ParquetFloorLobyLounge]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
            },
            [IDesignProjectCategoryId.HotelRoomFurniture]: {
                [IDesignProjectId.Bedding]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Bedhead]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.DressingRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.WoodenWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Cupboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.VanityUnit]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.GlassShowerScreen]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Mirror]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.TiledFloorRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.WaxedConcreteFloorRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.ParquetFloorRoom]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
            },
            [IDesignProjectCategoryId.BarRestaurant]: {
                [IDesignProjectId.CounterRight]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.CornerCounter]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.RoundedCounter]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.CentralCounter]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.DinnerTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.BistroTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.HighTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.EatStandingUp]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.HighChair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Sofa]: {
                    value : undefined,
                    min   : 0,
                    max   : 20,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.BarStool]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Bench]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.BenchLong]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.TiledFloorRestaurant]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.WaxedConcreteFloorRestaurant]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.ParquetFloorRestaurant]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
            },
            [IDesignProjectCategoryId.TerraceFurniture]: {
                [IDesignProjectId.OutdoorTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.OutdoorChair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.SummerKitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.GlassWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Separator]: {
                    value : undefined,
                    min   : 0,
                    max   : 50,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
                [IDesignProjectId.Sunbath]: {
                    value : undefined,
                    min   : 0,
                    max   : 100,
                },
            },
            [IDesignProjectCategoryId.Teaches]: {
                [IDesignProjectId.WoodenSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.MetalSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.NeonSign]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.Lights]: {
                [IDesignProjectId.LEDStrip]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
                [IDesignProjectId.RecessedSpot]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
                [IDesignProjectId.CeilingLight]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
                [IDesignProjectId.StreetLamp]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
                [IDesignProjectId.Chandelier]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
                [IDesignProjectId.WallLamp]: {
                    value : undefined,
                    min   : 0,
                    max   : 200,
                },
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 250000,
            budgetDefaultValue : 20000,
            marks              : budgetMarksBuilder(2000, 1000, 50000, 5000, 250000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default dpFastFoodForm;
